export default function CTA() {
    return (
        <section className="bg-[#d4af37] py-14 text-center">
            <h2 className="text-3xl font-bold text-black">
                Looking for Bulk Supply?
            </h2>
            <p className="mt-3">Contact Balaji Masale today</p>
        </section>
    );
}
